<template>
  <div class="home">
    <datav />
  </div>
</template>

<script>
// @ is an alias to /src

import datav from '../components/datav/index.vue'
export default {
  name: 'HomeView',
  components: {
    datav
  }
}
</script>
